import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const fetchArticles = createAsyncThunk(
  "newsArticals/fetchArticles",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/newsArticals", info);
      // console.log("data", data);
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch articles"
      );
    }
  }
);

// fetch by ID
export const fetchArticleBySlug = createAsyncThunk(
  "newsArticals/fetchArticleBySlug",
  async (slug, { rejectWithValue, fulfillWithValue }) => {
    try {
      // console.log("Fetching article with slug:", slug);
      const { data } = await api.post(`/newsArticals?slug=${slug}`);

      // Check if API returns an array
      if (Array.isArray(data.newsArticals)) {
        const foundArticle = data.newsArticals.find(
          (article) => article.slug === slug
        );
        if (!foundArticle) {
          return rejectWithValue("Article not found");
        }
        return fulfillWithValue(foundArticle);
      }

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch article");
    }
  }
);

const newsSlice = createSlice({
  name: "news",
  initialState: {
    articles: [],
    totalNewsArticles: 0,
    article: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArticles.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchArticles.fulfilled, (state, { payload }) => {
        // console.log(payload);
        state.articles = payload.newsArticals;
        state.totalNewsArticles = payload.totalNewsArticals;
      })
      .addCase(fetchArticles.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchArticleBySlug.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchArticleBySlug.fulfilled, (state, { payload }) => {
        state.article = payload;
        state.status = "succeeded";
      })
      .addCase(fetchArticleBySlug.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default newsSlice.reducer;
